import type { ConfigType } from '@plone/registry';
import { HomepageNewsKacheln } from './customizations/volto/components/manage/Blocks/Listing';
import { PdfListing } from './customizations/volto/components/manage/Blocks/Listing';
import installBlockQuote from './my-blocks/blockquote';
import installSliderBlock from './my-blocks/custom-slider-block';
import installInfoGrid from './my-blocks/info-grid';
import installInfoKacheln from './my-blocks/info-kacheln';
import installButtonBlock from './my-blocks/volto-button-block';
import installSeperatorBlock from './my-blocks/volto-separator-block';

function applyConfig(config: ConfigType) {
  // Add here your project's configuration here by modifying `config` accordingly

  config = installBlockQuote(config);
  config = installSliderBlock(config);
  config = installInfoGrid(config);
  config = installInfoKacheln(config);
  config = installButtonBlock(config);
  config = installSeperatorBlock(config);

  /* config.views = {
    ...config.views,
    contentTypesViews: {
      ...config.views.contentTypesViews,
    },
  }; */

  config.settings = {
    ...config.settings,
    // logo: '/customisations/components/theme/Logo/Logo.png',
    // devProxyToApiPath: 'http://localhost:8080/StiftungHochschulmedizin',
    //slate: {
    //  ...config.settings.slate,
    //  toolbarButtons: [...config.settings.slate.toolbarButtons, 'align-center'],
    //},
  };
  config.blocks.requiredBlocks = [];
  //{ console.log(config.settings) }
  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'HomepageNewsKacheln',
      title: 'Homepage News Kacheln',
      template: HomepageNewsKacheln,
      fullobjects: true,
    },
    {
      id: 'PdfListing',
      title: 'PDF Liste',
      template: PdfListing,
      fullobjects: true,
    },
  ];
  //config.settings.enableFatMenu = true;
  //config.settings.siteLabel = 'Plone Intranet';

  config.settings.supportedLanguages = ['de', 'en'];
  config.settings.defaultLanguage = 'de';

  return config;
}

export default applyConfig;
